import { TooltipTitle } from '@global-engineering-shared/gweb-material-global';
import { InfoIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Tooltip } from '@global-engineering-shared/gweb-material-ui';

import EntityDetailTooltipContent from 'features/EntityDetails/components/EntityDetails/EntityDetailTooltip/components/EntityDetailTooltipContent';
import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetailTooltip/EntityDetailTooltip.styles';

type EntityDetailTooltipProps = {
  previousEntityLabel: string;
  previousEntityValue: string;
};

const EntityDetailTooltip = ({
  previousEntityLabel,
  previousEntityValue,
}: EntityDetailTooltipProps) => {
  const classes = useStyles();

  return (
    <Tooltip
      title={
        <TooltipTitle
          Content={() => (
            <EntityDetailTooltipContent
              previousEntityLabel={previousEntityLabel}
              previousEntityValue={previousEntityValue}
            />
          )}
        />
      }
      placement="right-start"
      interactive
    >
      <span data-testid="info-status-icon" className={classes.icon}>
        <InfoIcon />
      </span>
    </Tooltip>
  );
};

export default EntityDetailTooltip;
